import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('click', '[data-register-newsletter]', function(event) {
  event.preventDefault();
  const $this = $(this);

  load(
    this,
    $.ajax($this.attr('href')),
  ).then(() => {
    $this.remove();
    $('[data-newsletter-registered]').show();
  });
});
